// extracted by mini-css-extract-plugin
module.exports = {"languageList":"LanguageList_languageList__LoZEm"};